import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Links = ({ items, className }) => (
  <div className={classNames('bmc-page-links', className)}>
    <ul className="flex flex-wrap justify-center items-center gap-10">
      {items &&
        items.map((item) => (
          <li key={item.id} className="mt-6 text-[#00afc9] font-medium">
            <span>{item.name || '-'}</span>
          </li>
        ))}
    </ul>
  </div>
);

Links.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
};

export default Links;
